import { ENDPOINTS } from 'defaults';
import { http } from './http';
const { ASSET } = ENDPOINTS;

export async function getAsset(key: String, client_id: Number) {
  const { GET } = ASSET;
  return http.get(GET.name, `${GET.url}?key=${key}&id_list=${client_id}`);
}
